import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=1683b2af&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1683b2af')) {
      api.createRecord('1683b2af', component.options)
    } else {
      api.reload('1683b2af', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=1683b2af&", function () {
      api.rerender('1683b2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/IoFormat/Components/Overview.vue"
export default component.exports